import React, { useState } from "react";
import { Badge, Button, Col, Dropdown, Form, Modal, Row, Toast, ToastContainer } from "react-bootstrap";
import { BsThreeDotsVertical, BsVectorPen } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { CustomToggleProps } from "../../../../../../core";
import { AdsStatementPageControllerImpl } from "../../../../business";
import { AdsStrings } from "../../../../business/core";
import { AdsStatementData } from "../../../interfaces";
import { AdsFactoryStrategyStatementButtonImpl } from "../../factories";

export const AdsStatement: React.FC<AdsStatementData> = ({ statement }) => {
    const navigate = useNavigate();
    const strings = AdsStrings['PTBR'].statement;
    const factory = new AdsFactoryStrategyStatementButtonImpl();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [toastingText, setToastingText] = useState<string | null>(null);
    const [unsubscribeReason, setUnsubscribeReason] = useState('');

    const handleInputChange = (e) => {
        const text = e.target.value;
        setUnsubscribeReason(text);
    };

    const handlerCancelPlan = async (id: string) => {
        try {
            setLoading(true);
            const controller = new AdsStatementPageControllerImpl();
            const cancelment = await controller.cancelAds(id, unsubscribeReason);
            if (!cancelment.success) {
                setToastingText(cancelment.response);
                setLoading(false);
            } else {
                navigate("/");
            }
        } catch (error) {
            setLoading(false);
            setToastingText(error.message);
        }
    }

    const CustomToggle = React.forwardRef<HTMLAnchorElement, CustomToggleProps>(({ children, onClick }, ref) => (
        <a href="/#" ref={ref} onClick={e => { e.preventDefault(); onClick(e); }}>
            <BsThreeDotsVertical />
            {children}
        </a>
    ));

    return (
        <>
            <ToastContainer>
                <Toast
                    bg={"danger"}
                    onClose={() => setToastingText(null)}
                    show={toastingText !== null ? true : false}
                    delay={5000}
                    autohide
                >
                    <Toast.Body className={"text-white"}>
                        {toastingText !== null ? toastingText : null}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            <Row style={{ overflow: "hidden" }}>
                <Col>
                    {statement.data.map((subscription, key) => (
                        <>
                            <Row key={key} className="py-3" style={{ borderBottom: "1px solid #CCCCCC" }}>
                                {subscription.status === 'ACTIVATED' ? (
                                    <Col xs={12} className="text-end">
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="" onClick={() => setShowModal(true)}>{strings.status.ACTIVATED.dropdown?.item1.description}</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>


                                        <Modal show={showModal} onHide={() => setShowModal(false)}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>{strings.status.ACTIVATED.modal_title}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                {strings.status.ACTIVATED.modal_description}
                                                <Form>
                                                    <Form.Group className="mb-3 mt-3">
                                                        <Form.Label>{strings.nps.subscribe_cancelment}</Form.Label>
                                                        <Form.Control as="textarea" rows={3} onChange={handleInputChange} />
                                                    </Form.Group>
                                                </Form>
                                            </Modal.Body>

                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={() => setShowModal(false)}>
                                                    {strings.status.ACTIVATED.modal_button_cancel_label}
                                                </Button>
                                                <Button variant="primary" onClick={() => handlerCancelPlan(subscription.id)} disabled={isLoading}>
                                                    {strings.status.ACTIVATED.modal_button_confirm_label}
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </Col>
                                ) : null}
                                <Col>
                                    <p>
                                        <BsVectorPen /> {strings.plan} {subscription.description}{" "}
                                        <Badge bg={strings.status[subscription.status].badge_style}>{strings.status[subscription.status].title}</Badge><br />
                                        <small>{strings.payment_frequency[subscription.frequency]}</small><br />
                                    </p>
                                </Col>
                                <Col>
                                    <small>
                                        <p>
                                            {strings.expires_label}<br />
                                            {subscription.expires}
                                        </p>
                                        {strings.payment_method}<br />
                                        {subscription.payment_method}
                                    </small>
                                </Col>
                                <Col>
                                    <small>
                                        <p>
                                            {strings.amount}<br />
                                            {subscription.amount}
                                        </p>
                                    </small>
                                </Col>
                                <Col>
                                    {factory.createButton(subscription, statement.isUpdateable)}
                                </Col>
                            </Row>
                        </>
                    ))}
                </Col>
            </Row >
        </>
    );
}
